<template>
  <div class="equLoss">
     <div class='con'>
      <template v-if='isLoss==2'>
           <img src="@/assets/img/mine/noLoss.png" class='imgs'>
           <div class="gray font16">设备已挂失</div>
           <div class="noteCon">
               <p class="gray font15">您可以尝试一下操作尝试找回设备：</p>
               <p>1、拨打电话，如果有人拾取，可以联系归还<br />2、查看设备最后上报的位置</p>
           </div>
       </template>
       <template v-else>
          <div class="title"><img src="../../assets/img/equLoss.png" alt=""></div>
          <div class="equloss_content">
            <div class="equloss_flex" >
              <div class="flex_left"><img style="margin-top: 0;" src="../../assets/img/equipment/loc.png" alt=""></div>
              <div class="flex_right">
                <div class="right_top" style="margin-top: 0;">位置上报</div>
                <div class="right_bottom">挂失后，只要学生终端设备联网成功，会自动上报位置到在鸿助手</div>
              </div>
            </div>
            <div class="equloss_flex">
                <div class="flex_left"><img src="../../assets/img/equipment/phone.png" alt=""></div>
                <div class="flex_right">
                  <div class="right_top">安全通话</div>
                  <div class="right_bottom">挂失后，家长可以向设备拨打电话，如果被他人拾取，可以沟通归还。</div>
                </div>
            </div>
            <div class="equloss_flex">
              <div class="flex_left"><img src="../../assets/img/equipment/suo.png" alt=""></div>
              <div class="flex_right" style="border:none;">
                <div class="right_top">设备锁定</div>
                <div class="right_bottom">除了通话，其他功能均被冻结，他人无法使用</div>
              </div>
            </div>
          </div>
       </template>
       
       
       <div class="btnFixed" v-if="imei"> 
            <div class="btn-primary" @click="getImei" >{{isLoss==1?'挂失':'取消挂失'}}</div>
       </div> 
       <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" vertical>请稍等，正在等待设备返回结果</van-loading></div>
     </div>
  </div>
</template>
<script>
  import {getLossStatus,unLoss,loss} from "@/api/api.equipment";
  export default {
    data() {
      return {
        isLoss:'',
        isclick:false,
        loading:false,
        imei:''
      }
    },
    created(){
      let option={
            success:(data)=>{
              this.imei=data.imei;
              if(this.imei){
                this.getLoss();
              }
              
            }
          }
       this.getImeis(option);
    },  
    methods: {
      getLoss(){
        getLossStatus({imei:this.imei}).then(data=>{
             this.isLoss=data.result;
        })
      },
      getImei(){
        this.$dialog.confirm({
            title:'确认挂失',
            message: '挂失后设备将被冻结，仅提供定位和通话服务',
            messageAlign:'left',
            confirmButtonText:'挂失'
        })
          .then(() => {
            let option={
            success:(data)=>{
                if(data.deviceStatus!==1){
                    this.$toast('设备离线，无法操作');
                    return false;
                }
                this.handleClick();
              }
            }
            this.getImeis(option);
          })
          .catch(() => {
            // on cancel
          });
         
      },
      handleClick(){
        if(this.isLoss==1){
          loss({imei:this.imei}).then(()=>{
             this.loading=true;
             setTimeout(()=>{
               this.loading=false;
               this.getLoss();
             },5000)
         })
        }else{
          unLoss({imei:this.imei}).then(()=>{
             this.loading=true;
             setTimeout(()=>{
               this.loading=false;
               this.getLoss();
             },5000)
         })
        }
      }
     
    },
  }
</script>
<style lang="scss" >
.equLoss{
  font-size:.14rem;
  line-height: .14rem;
  padding:.12rem;
  .title{
    // height: 106px;
    width: 100%;
    border-radius: 8px 8px 8px 8px;
    margin: 0 0 0.1rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
 .con{
   text-align: center;
   line-height: .22rem;
   position: relative;
   .imgs{
    width: 60%;
    max-width: 240px;
    margin-top: .3rem;
   }
   .text{
     text-align: left;
     width: 94%;
     margin:.1rem auto;
     font-size: .14rem;
     color:#1d3151;
   }
  
 }
 .equloss_content{
  background: #FFFFFF;
  border-radius: 8px 8px 8px 8px;
  padding: 0.12rem;
 }
 .equloss_flex{
  display: flex;
 
  .flex_left{
    // width: 10%;
    img{
      width: 0.2rem;
      height: 0.2rem;
      margin-top:0.12rem ;
    }
  }
  .flex_right{
    padding-left: .05rem;
     border-bottom: 1px solid #dcdcdc;
    .right_top{
      text-align: left;
      font-size: 0.17rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: rgba(0,0,0,0.9);
      margin-bottom: 0.05rem;
      margin-top: 0.12rem;
    }
    .right_bottom{
      font-size: 0.15rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: rgba(0,0,0,0.6);
      text-align: left;
      margin-bottom: 0.12rem;

    }
  }
 }
 .noteCon{
  font-size: .15rem;
  text-align: left;
  line-height: .25rem;
  color:rgba(0,0,0,.9);
  padding:0rem .2rem;
  .gray{
    padding:.2rem 0rem .1rem;
  }
 }
}

</style>